import NavBar from "../common/NavBar";
import NavBarFooter from "../common/NavBarFooter";

const Contact = () => {
    return (
        <div className="outline">
            <NavBar />
            <h1>Contact</h1>
            <p>Send us a message on Github</p>
            <NavBarFooter />
        </div>
    )
}

export default Contact;